import React from "react";
import styles from './index.module.scss'

interface LabelProps {
    title: string,
    iconUrl?: string,
    icon?: React.ReactNode,
    backgroundColor?: string,
    color?: string,
}

export default function Label({ title, backgroundColor, iconUrl, icon, color }: LabelProps){
    return (
        <div className={styles.label} style={{backgroundColor, color}}>
            <div className={styles.label__icon}>
                {icon ? icon : iconUrl ? <img src={iconUrl} alt="Icon"/> : null}
            </div>
            {title}
        </div>
    )
}
